__turbopack_context__.v({
  "articleTitle": "DynamicLatestNews-module-scss-module__BOv0Eq__articleTitle",
  "cityChevron": "DynamicLatestNews-module-scss-module__BOv0Eq__cityChevron",
  "cityDivider": "DynamicLatestNews-module-scss-module__BOv0Eq__cityDivider",
  "cityNameActive": "DynamicLatestNews-module-scss-module__BOv0Eq__cityNameActive",
  "cityNameEntering": "DynamicLatestNews-module-scss-module__BOv0Eq__cityNameEntering",
  "cityNameExiting": "DynamicLatestNews-module-scss-module__BOv0Eq__cityNameExiting",
  "cityNameSet": "DynamicLatestNews-module-scss-module__BOv0Eq__cityNameSet",
  "cityNamesViewport": "DynamicLatestNews-module-scss-module__BOv0Eq__cityNamesViewport",
  "cityPrimary": "DynamicLatestNews-module-scss-module__BOv0Eq__cityPrimary",
  "citySecondary": "DynamicLatestNews-module-scss-module__BOv0Eq__citySecondary",
  "completed": "DynamicLatestNews-module-scss-module__BOv0Eq__completed",
  "discoverCta": "DynamicLatestNews-module-scss-module__BOv0Eq__discoverCta",
  "heading": "DynamicLatestNews-module-scss-module__BOv0Eq__heading",
  "leftPanel": "DynamicLatestNews-module-scss-module__BOv0Eq__leftPanel",
  "leftPanelBackground": "DynamicLatestNews-module-scss-module__BOv0Eq__leftPanelBackground",
  "leftPanelContent": "DynamicLatestNews-module-scss-module__BOv0Eq__leftPanelContent",
  "leftPanelCta": "DynamicLatestNews-module-scss-module__BOv0Eq__leftPanelCta",
  "leftPanelOverlay": "DynamicLatestNews-module-scss-module__BOv0Eq__leftPanelOverlay",
  "progressBar": "DynamicLatestNews-module-scss-module__BOv0Eq__progressBar",
  "progressFill": "DynamicLatestNews-module-scss-module__BOv0Eq__progressFill",
  "progressSegment": "DynamicLatestNews-module-scss-module__BOv0Eq__progressSegment",
  "rightPanel": "DynamicLatestNews-module-scss-module__BOv0Eq__rightPanel",
  "section": "DynamicLatestNews-module-scss-module__BOv0Eq__section",
  "slideContainer": "DynamicLatestNews-module-scss-module__BOv0Eq__slideContainer",
  "slideContent": "DynamicLatestNews-module-scss-module__BOv0Eq__slideContent",
  "slideImage": "DynamicLatestNews-module-scss-module__BOv0Eq__slideImage",
  "slideOverlay": "DynamicLatestNews-module-scss-module__BOv0Eq__slideOverlay",
  "subtitle": "DynamicLatestNews-module-scss-module__BOv0Eq__subtitle",
  "timezoneLabel": "DynamicLatestNews-module-scss-module__BOv0Eq__timezoneLabel",
  "wheelContainer": "DynamicLatestNews-module-scss-module__BOv0Eq__wheelContainer",
  "wheelImage": "DynamicLatestNews-module-scss-module__BOv0Eq__wheelImage",
});
